import { useMemo } from 'react';
import { IPostCommentSelectReturn } from '../../../interfaces/post.interface';
import { IUseMetaRole } from '../../../interfaces/hook.interface';
import { TRoleAccess } from '../../../constant/storage';

export const useMetaRole = (
  fetchedCommentList: IPostCommentSelectReturn,
  commentList: IPostCommentSelectReturn[]
): IUseMetaRole => {
  const commentListMeta = useMemo(() => {
    const clone = fetchedCommentList;
    return {
      totalCount: clone?.meta?.totalCount || commentList?.length,
      hasNextPage: clone?.meta?.hasNextPage || false,
      pageSize: clone?.meta?.pageSize || 0,
      currentPage: clone?.meta?.currentPage || 0,
    };
  }, [commentList?.length, fetchedCommentList]);

  const commentSectionRole = useMemo(() => {
    const clone = fetchedCommentList;
    return clone?.userRole as TRoleAccess;
  }, [fetchedCommentList]);

  return { commentListMeta, commentSectionRole };
};
